import { Spin } from "antd";
import React from "react";

export const LoadingComponent = ({ children, loading, title="Loading..." }) => {
  return loading ? (
    <Spin size="large" tip={title}>
      {children}
    </Spin>
  ) : (
    <>{children}</>
  );
};
